import React, {useState,useEffect} from 'react';
import useStyles from './Styles';
import Grid from '@mui/material/Grid';
//import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
//import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import FormGroup from '@mui/material/FormGroup';
//import FormHelperText from '@mui/material/FormHelperText';
import Button from '@mui/material/Button';
//import TextField from '@mui/material/TextField';
//import Checkbox from '@mui/material/Checkbox';
import Select,{SelectChangeEvent} from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import SearchIcon from '@mui/icons-material/Search';
import DeleteIcon from '@mui/icons-material/Delete';
import {Tools} from './Tools';
import {Inc,Dataset,ReturnBaseSearchCondition,SortOption} from './Inc';
import Title from './Title';
import AppBank from './AppBank';

interface ReturnListSearchProps {
    update(cond:ReturnBaseSearchCondition,page:number): void,
	bankKey:string,
	bank:AppBank,
}

const ReturnListSearch = (props:ReturnListSearchProps)=> {
    const classes = useStyles();
    const [states,setStates] = useState(Inc.defaultReturnBaseSearchCondition());

    const update = ()=>{
		props.bank.set(props.bankKey,JSON.stringify(states));
        props.update(states,1);
    }
	//const handleChange = (name: keyof ReturnBaseSearchCondition) => (event: React.ChangeEvent<HTMLInputElement>) => {
	//	setStates({ ...states, [name]: event.target.value });
	//};
	//const handleChangeNumber = (name: keyof ReturnBaseSearchCondition) => (event: React.ChangeEvent<HTMLInputElement>) => {
    //    setStates({ ...states, [name]: Tools.toHan(event.target.value) });
    //    //setStates({ ...states, [name]: event.target.value });
	//};
	const handleChangeSelect = (name: keyof ReturnBaseSearchCondition) => (event: SelectChangeEvent) => {
		setStates({ ...states, [name]: event.target.value });
    };
	const handleChangeOption = (name: keyof SortOption) => (event: SelectChangeEvent) => {
        let option = states.option;
        option[name] = event.target.value;
		setStates({ ...states, "option": option});
    };
	//const handleChangeCheckboxes = (name: keyof ReturnBaseSearchCondition,index:number) => (event: React.ChangeEvent<HTMLInputElement>) => {
	//	let boolList:boolean[] = [];
	//	let idList:string[] = [];
	//	let blName:string = "";
	//	let datas:Dataset[] = [];
	//	if( blName!=="" ){
	//		if( event.target.checked ){
	//			boolList[index] = true;
	//		} else {
	//			boolList[index] = false;
	//		}
	//		for( let i=0 ; i<boolList.length ; i++ ){
	//			if( boolList[i] ){
	//				idList.push( datas[i].id );
	//			}
	//		}
	//		setStates({ ...states, [blName]: boolList, [name]: idList });
	//	}
	//};
	const resetCondition = ()=>{
		setStates(Inc.defaultReturnBaseSearchCondition());
	}
    
	//const checkboxes = (id:keyof ReturnBaseSearchCondition,list:Dataset[])=>{
	//	const tmp = list.map( (data:Dataset,index:number)=>{
	//		const key = id+index;
	//		let v:boolean = false;
	//		return (
	//			<FormControlLabel
	//		    	key={key}
	//				control={
	//				<Checkbox
	//					checked={v}
	//					onChange={handleChangeCheckboxes(id,index)}
	//					value={String(data.id)}
	//					color="primary"
	//					className={classes.checkbox}
	//				/>
	//				}
	//				label={data.label}
	//			/>
	//		);
	//	});
	//	return (
	//		<div className={classes.checkboxes}>
	//			{tmp}
	//		</div>
	//	)
    //};

    useEffect( ()=>{
		if( props.bank.has(props.bankKey) ){
			//console.log("load");
			const cond = JSON.parse(props.bank.get(props.bankKey));
			setStates(cond);
			props.update(cond,1);
		} else {
			props.update(states,1);
		}
    },[])
    
    const years = Tools.getSelectYears();
    const months = Tools.getSelectMonths();
    const orders:Dataset[] = [
        {
            id:"return_base_id",
            label:"申請日",
        },
        {
            id:"delivery_date",
            label:"発送予定日",
        },
    ]
    const targets:Dataset[] = [
        {
            id:"regist_time",
            label:"申請日",
        },
        {
            id:"delivery_date",
            label:"発送予定日",
        },
    ]


    let error = false;

	return (
		<div id="consign_list_search">
            
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Title text="検索条件" size={2}/>
                </Grid>
                <Grid item xs={6}>
                    <div className={classes.searchButtons}>
                        <Button variant="outlined" color="primary" onClick={update} disabled={error}><SearchIcon/>検索</Button>
                    </div>
                </Grid>
                <Grid item xs={12} sm={6} md={12}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>状態</FormLabel>
                        
                        <Select
                            value={states.status}
                            onChange={handleChangeSelect('status')}
                            inputProps={{
                                name: 'status',
                                id: 'status-simple',
                            }}
                            margin="none"
                            className={classes.select}
							variant="standard"
                        >
                            <MenuItem key="status" value="">　</MenuItem>
                            {Inc.returnStatus.map((option:Dataset,index:number) => {
                                const key = "status"+index;
                                return (
                                    <MenuItem key={key} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={12}>
                    <FormGroup row>
						<FormControl className={classes.formControl} >
							<FormLabel component="label" className={classes.formLabel}>手続き年月</FormLabel>
                            <Select
                                value={states.date_target}
                                onChange={handleChangeSelect('date_target')}
                                inputProps={{
                                    name: 'target',
                                    id: 'target-simple',
                                }}
                                margin="none"
								variant="standard"
                                className={classes.select}
								style={{minWidth:'8em'}}
                            >
                                {targets.map((option:Dataset,index:number) => {
                                    const key = "target"+index;
                                    return (
                                        <MenuItem key={key} value={option.id}>
                                            {option.label}が
                                        </MenuItem>
                                    )
                                })}
                            </Select>
						</FormControl>
                        <FormControl className={classes.formControl} >
                            <FormLabel component="label" className={classes.formLabel}>　</FormLabel>
                            
                            <Select
                                value={states.date_year}
                                onChange={handleChangeSelect('date_year')}
                                inputProps={{
                                    name: 'year',
                                    id: 'year-simple',
                                }}
                                margin="none"
								variant='standard'
                                className={classes.select}
								style={{width:'6em'}}
                            >
                                <MenuItem key="year0" value="">　</MenuItem>
                                {years.map((option:Dataset,index:number) => {
                                    const key = "year"+index;
                                    return (
                                        <MenuItem key={key} value={option.id}>
                                            {option.label}
                                        </MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                        <FormControl className={classes.formControl}>
                            <FormLabel component="label" className={classes.formLabel}>　</FormLabel>
                            <Select
                                value={states.date_month}
                                onChange={handleChangeSelect('date_month')}
                                inputProps={{
                                    name: 'month',
                                    id: 'month-simple',
                                }}
                                margin="none"
								variant='standard'
                                className={classes.select}
								style={{width:'4em'}}
                            >
                                <MenuItem key="month0" value="">　</MenuItem>
                                {months.map((option:Dataset,index:number) => {
                                    const key = "month"+index;
                                    return (
                                        <MenuItem key={key} value={option.id}>
                                            {option.label}
                                        </MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                    </FormGroup>
                </Grid>
                <Grid item xs={4} md={6} lg={6}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>表示基準</FormLabel>
                        
                        <Select
                            value={states.option.order}
                            onChange={handleChangeOption('order')}
                            inputProps={{
                                name: 'order',
                                id: 'order-simple',
                            }}
                            margin="none"
							variant='standard'
                            className={classes.select}
                        >
                            {orders.map((option:Dataset,index:number) => {
                                const key = "order"+index;
                                return (
                                    <MenuItem key={key} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={4} md={6} lg={6}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>表示順</FormLabel>
                        
                        <Select
                            value={states.option.sort}
                            onChange={handleChangeOption('sort')}
                            inputProps={{
                                name: 'sort',
                                id: 'sort-simple',
                            }}
                            margin="none"
							variant='standard'
                            className={classes.select}
                        >
                            {Inc.sorts.map((option:Dataset,index:number) => {
                                const key = "sort"+index;
                                return (
                                    <MenuItem key={key} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={4} md={6} lg={6}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>表示件数</FormLabel>
                        
                        <Select
                            value={states.option.per_page}
                            onChange={handleChangeOption('per_page')}
                            inputProps={{
                                name: 'per_page',
                                id: 'per_page-simple',
                            }}
                            margin="none"
							variant='standard'
                            className={classes.select}
                        >
                            {Inc.perPages.map((option:Dataset,index:number) => {
                                const key = "per_page"+index;
                                return (
                                    <MenuItem key={key} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>

            </Grid>
            <Button variant="outlined" fullWidth={true} className={classes.buttonReset} onClick={resetCondition}><DeleteIcon/>検索条件のリセット</Button>
		</div>
	);
}

export default ReturnListSearch;
